import { API } from 'aws-amplify'
import { ISubscriptionResponse } from '../models/ISubscription';

export default class SubscriptionsService {
    static getAllSubscriptions(): Promise<ISubscriptionResponse[]> {
        return API.get('chargebeeSubscriptionAPI', '/chargebeeSubscription/null', null)
            .then(response => response.chargebeeSubscriptions.Items);
    }
}